<template>
  <div class="water">
    <div class="zhiwei">
      <div class="title">
        <titleCard title='CKD一体化分级管理平台'></titleCard>
      </div>
      <div class="content">
        <div class="left animate__animated wow animate__fadeInLeft">
          针对CKD患者进行个性化、规范化、系统化的自我管理平台，实现CKD患者全病程覆盖，从而提高患者依从性，促进患者持续地健康管理。</div>
        <div class="right animate__animated wow animate__fadeInRight">
          <img src="https://yyt-ows.oss-cn-beijing.aliyuncs.com/87C1073AF9184102B96B4221A930602D-6-2.png" alt="">
        </div>
      </div>
      <!-- 核心功能 -->
      <div class="hexin">
        <div class="title">
          <titleCard title="核心功能"></titleCard>
          <div class="title-txt">达成信息高效传递，提升设备售后服务质量，实现多样化，更贴心的客户服务。</div>
        </div>
        <div class="mypcbox">
          <div class="mybox">
            <div class="pic animate__animated wow animate__fadeInLeft"><img
                src="../../assets/image/News/huanzhe/huanzhe2.webp" alt=""></div>
            <div class="txt animate__animated wow animate__fadeInRight">
              <img src="../../assets/image/News/huanzhe/icon1.webp" alt="">
              <h3>随访管理</h3>
              <p>覆盖患者全生命周期，<br>定制个性化随访方案</p>
            </div>
          </div>
          <div class="mybox">
            <div class="txt txt2 animate__animated wow animate__fadeInLeft">
              <img src="../../assets/image/News/huanzhe/icon2.webp" alt="">
              <h3>预警干预</h3>
              <p>监控各项指标，异常数据实时<br>通知医患双方，给予及时治疗</p>
            </div>
            <div class="pic animate__animated wow animate__fadeInRight"><img
                src="../../assets/image/News/huanzhe/huanzhe3.webp" alt=""></div>
          </div>
          <div class="mybox">
            <div class="pic animate__animated wow animate__fadeInLeft"><img
                src="../../assets/image/News/huanzhe/huanzhe4.webp" alt=""></div>
            <div class="txt txt2 animate__animated wow animate__fadeInRight">
              <img src="../../assets/image/News/huanzhe/icon3.webp" alt="">
              <h3>数据记录</h3>
              <p>将每一位患者的信息及相关诊疗数据进行<br>系统化管理和记录</p>
            </div>
          </div>
          <div class="mybox">
            <div class="txt txt2 animate__animated wow animate__fadeInLeft">
              <img src="../../assets/image/News/huanzhe/icon4.webp" alt="">
              <h3>科普宣教</h3>
              <p>不同分期给予慢性肾病患者合理用药、<br>膳食、运动等治疗措施的个性</p>
            </div>
            <div class="pic animate__animated wow animate__fadeInRight"><img
                src="../../assets/image/News/huanzhe/huanzhe5.webp" alt=""></div>
          </div>
        </div>
        <div class="myiosbox">
          <div class="mybox">
            <div class="pic animate__animated wow animate__fadeInUp"><img
                src="../../assets/image/News/huanzhe/huanzhe2.webp" alt=""></div>
            <div class="txt animate__animated wow animate__fadeInUp">
              <img src="../../assets/image/News/huanzhe/icon1.webp" alt="">
              <div class="text">
                <h3>随访管理</h3>
                <p>覆盖患者全生命周期，定制个性化随访方案</p>
              </div>
            </div>
          </div>
          <div class="mybox">
            <div class="pic animate__animated wow animate__fadeInUp"><img
                src="../../assets/image/News/huanzhe/huanzhe3.webp" alt=""></div>
            <div class="txt animate__animated wow animate__fadeInUp">
              <img src="../../assets/image/News/huanzhe/icon2.webp" alt="">
              <div class="text">
                <h3>预警干预</h3>
                <p>监控各项指标，异常数据实时通知医患双方，给予及时治疗</p>
              </div>
            </div>
          </div>
          <div class="mybox">
            <div class="pic animate__animated wow animate__fadeInUp"><img
                src="../../assets/image/News/huanzhe/huanzhe4.webp" alt=""></div>
            <div class="txt animate__animated wow animate__fadeInUp">
              <img src="../../assets/image/News/huanzhe/icon3.webp" alt="">
              <div class="text">
                <h3>数据记录</h3>
                <p>将每一位患者的信息及相关诊疗数据进行系统化管理和记录</p>
              </div>
            </div>
          </div>
          <div class="mybox">
            <div class="pic animate__animated wow animate__fadeInUp"><img
                src="../../assets/image/News/huanzhe/huanzhe5.webp" alt=""></div>
            <div class="txt animate__animated wow animate__fadeInUp">
              <img src="../../assets/image/News/huanzhe/icon4.webp" alt="">
              <div class="text">
                <h3>科普宣教</h3>
                <p>不同分期给予慢性肾病患者合理用药、膳食、运动等治疗措施的个性</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 慢性肾病一体化分级管理 -->
      <div class="ckd animate__animated wow animate__fadeInUp">
        <div class="title">
          <titleCard title="慢性肾病一体化分级管理"></titleCard>
        </div>
        <div class="contentbox">
          <div class="leftbox">
            <div class="txtbox">
              <h3>个性化方案</h3>
              <p>为患者定制全流程、个性化的行为干预和疾病管理方案</p>
            </div>
            <div class="txtbox">
              <h3>医联体联动</h3>
              <p>发挥不同级别医疗机构的特点，从全局的观点有效管理患者</p>
            </div>
            <div class="txtbox mnone">
              <h3>全病程监测</h3>
              <p>规范化的随访管理，异常指标预警需要干预时，给予及时处 理（线上指导、线下复诊、转诊治疗） </p>
            </div>
          </div>
          <div class="rightbox">
            <img src="../../assets/image/News/huanzhe/huanzhe6.webp" alt="">
          </div>
        </div>
      </div>
    </div>
    <footerCard name='吴老师' phone='138-1097-5144'></footerCard>
  </div>
</template>

<script>
import footerCard from '../../components/footer-card2.vue'
import titleCard from '../../components/title-card.vue'
export default {
  data() {
    return {

    }
  },
  components: {
    footerCard,
    titleCard
  },
  created() {

  },
  mounted() {

  },
  methods: {
  }
}
</script>

<style scoped lang="scss">
.water {
  .zhiwei {
    .title {
      padding: 1rem 0 1.4316rem 0;
      @media screen and (max-width: 540px) {
        padding: 37px 0 54px 0;
      }
    }
    .content {
      height: 4.5053rem;
      display: flex;
      align-items: center;
      margin-bottom: 2.2632rem;
      @media screen and (max-width: 540px) {
        display: block;
        box-sizing: border-box;
        padding: 0 26px;
        height: 100%;
      }
      .left {
        width: 7.2211rem;
        margin-right: 1.0947rem;
        margin-left: 2.3895rem;
        color: #272b2d;
        line-height: 0.4421rem;
        font-size: 0.2526rem;
        @media screen and (max-width: 540px) {
          width: 100%;
          font-size: 15px;
          line-height: 26px;
          margin: 0;
        }
      }
      .right {
        width: 6.2526rem;
        @media screen and (max-width: 540px) {
          width: 100%;
          height: 240px;
          margin-top: 20px;
        }
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    .hexin {
      .title {
        padding-bottom: 0.7895rem;
        .title-txt {
          text-align: center;
          width: 70%;
          margin: 0 auto;
          color: #666666;
          font-size: 0.2526rem;
          padding: 22px 0 40px 0;
          @media screen and (max-width: 540px) {
          font-size: 15px;
        }
        }
      }
      .titletxt {
        color: #666666;
        text-align: center;
        font-size: 0.2526rem;
        line-height: 0.4211rem;
        padding-bottom: 2.1053rem;
      }
      .mypcbox {
        @media screen and (max-width: 540px) {
          display: none;
        }
        .mybox {
          display: flex;
          padding: 0 1.6842rem;
          align-items: center;
          justify-content: center;
          margin-bottom: 1.0526rem;
          .pic {
            width: 50%;
            height: 5.2632rem;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .txt {
            padding-left: 1.1158rem;
            box-sizing: border-box;
            width: 50%;
            img {
              display: block;
              width: 0.5053rem;
              height: 0.4737rem;
            }
            h3 {
              margin: 0;
              padding: 0.3263rem 0 0.4211rem 0;
              color: #333333;
              font-size: 0.2947rem;
            }
            p {
              font-size: 0.2526rem;
              color: #333333;
              line-height: 0.4211rem;
            }
          }
          .txt2 {
            padding-left: 2.1053rem;
          }
        }
      }
      .myiosbox {
        display: none;
        @media screen and (max-width: 540px) {
          display: block;
        }
        margin-bottom: 50px;
        .mybox {
          padding: 0 14px;
          align-items: center;
          justify-content: center;
          margin-bottom: 36px;
          .pic {
            width: 100%;
            height: 240px;
            margin-bottom: 23px;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .txt {
            padding-left: 5px;
            box-sizing: border-box;
            width: 100%;
            display: flex;
            align-items: center;
            img {
              display: block;
              width: 30px;
              height: 28px;
              padding-right: 18px;
            }
            .text {
              h3 {
                margin: 0;
                padding: 0.3263rem 0 0.4211rem 0;
                color: #333333;
                font-size: 17px;
              }
              p {
                font-size: 15px;
                color: #333333;
                padding-right: 50px;
                line-height: 25px;
              }
            }
          }
          .txt2 {
            padding-left: 2.1053rem;
          }
        }
      }
    }
    .ckd {
      .title {
        padding: 0.4211rem 0 1.3684rem 0;
        @media screen and (max-width: 540px) {
          padding-bottom: 45px;
        }
      }
      .contentbox {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 1.2632rem;
        height: 5.7895rem;
        @media screen and (max-width: 540px) {
          display: block;
          height: 100%;
        }
        .leftbox {
          width: 50%;
          padding-left: 1.7053rem;
          padding-right: 1.7895rem;
          box-sizing: border-box;
          @media screen and (max-width: 540px) {
            width: 100%;
            padding: 0 22px;
          }
          .txtbox {
            margin-bottom: 0.6316rem;
             @media screen and (max-width: 540px) {
                margin-bottom: 35px;
              }
            h3 {
              margin: 0;
              color: #0ca6eb;
              font-size: 0.2947rem;
              padding-bottom: 0.2105rem;
              @media screen and (max-width: 540px) {
                font-size: 16px;
              }
            }
            p {
              color: #333333;
              font-size: 0.2421rem;
              line-height: 0.5263rem;
              @media screen and (max-width: 540px) {
                font-size: 14px;
                line-height: 25px;
              }
            }
          }
          .mnone {
            margin: 0;
          }
        }
        .rightbox {
          width: 50%;
          height: 100%;
          @media screen and (max-width: 540px) {
            width: 100%;
            padding: 0 22px;
            box-sizing: border-box;
            margin-top: 30px;
          }
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }
}
</style>
